/**
 * InputField Component
 * 
 * This component renders Input field for autocomplete field
 * 
 * */
import React from 'react';
import { InputAdornment, TextField } from '@material-ui/core';
import SearchIcon from './SearchIcon';
import EndAdornment from './EndAdornment';
import { InputFieldDiv } from './AutoComplete.styled';

export default function InputField(props)
    { 
        const { params,
                value,
                height,
                classes,
                disabled,
                onChange,
                onClose,
                isMobile,
                Search,
                showSearchIcon,
                inputRef,
                inputValue,
                placeholder,
                searchIconHeight,
                searchIconWidth,
                isFromShiptoAddress,
                isFromPhysician,
                isFromSurgery,
                isFromMazorCase,
                InputContainer,
                isAddItemSearchItem,
                autoCompleteInputFieldStyle,
                readOnly,
                isProductSearch,
                changeBackgroundDisabled,
                loading, // <-- add loading prop
                isAddProxy = false
            } = props;
        return ( 
        <InputFieldDiv
            ref={params?.InputProps?.ref} >
            <TextField
                {...params}
                id="outlined-adornment-weight"
                classes={{
                    root: classes.customTextField,
                    notchedOutline: classes.notchedOutline,
                }} 
                InputProps={{
                    ...params.InputProps,
                    disabled:disabled, 
                    startAdornment: 
                    ((showSearchIcon &&
                    !isAddItemSearchItem && inputValue?.length < 1) ||
                    (isAddItemSearchItem && showSearchIcon))? (
                        <InputAdornment position="start" 
                        className={classes.startAdornment} >
                        <SearchIcon
                            isAddItemSearchItem={isAddItemSearchItem}
                            showSearchIcon={showSearchIcon}
                            isProductSearch={isProductSearch}
                            Search={Search}
                            searchIconHeight={searchIconHeight}
                            searchIconWidth={searchIconWidth}
                            disabled={disabled}
                            onChange={onChange}
                        />
                        </InputAdornment>
                    ):null,
                    endAdornment: (
                        <>
                        <InputAdornment position="end">
                        <EndAdornment
                            value={value}
                            height={height}
                            disabled={disabled}
                            onChange={onChange}
                            onClose={onClose}
                            inputValue={inputValue}
                            isMobile={isMobile}
                            isFromShiptoAddress={isFromShiptoAddress}
                            isFromPhysician={isFromPhysician}
                            isFromSurgery={isFromSurgery}
                            isFromMazorCase={isFromMazorCase}
                            classes={classes}
                        />
                        {loading && isAddProxy ? (
                            <InputAdornment position="end">
                                {/* Material-UI CircularProgress spinner for loading state */}
                                <span style={{ display: 'flex', alignItems: 'center', marginLeft: 8 }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10" stroke="#1976d2" strokeWidth="4" fill="none" opacity="0.2" />
                                        <path d="M12 2 a10 10 0 0 1 10 10" stroke="#1976d2" strokeWidth="4" fill="none" />
                                    </svg>
                                </span>
                            </InputAdornment>
                        ) : null}
                        </InputAdornment>
                        {params?.InputProps?.endAdornment}
                        </>
                    ),
                }} 
                inputProps={{
                    ...params.inputProps, 
                    onKeyDown: readOnly ? (e) => e.preventDefault() : undefined,
                    onPaste: readOnly ? (e) => e.preventDefault() : undefined,
                    onInput: readOnly ? (e) => e.preventDefault() : undefined,  
                    onFocus: readOnly ? (e) => e.target.blur() : undefined,
                }}
                placeholder={placeholder}
                style={
                    autoCompleteInputFieldStyle ||
                    InputContainer({ 
                        changeBackgroundDisabled
                    })
                }
                isSurgery={true}
                labelWidth={0}
                inputRef={inputRef}
            />
        </InputFieldDiv>);
    }